export const API_ENDPOINT = 'search-tile';


// WEBPACK FOOTER //
// ./src/state/modules/search-tile/configurations/endpoints.js